import api from '..';

export type createM4UCardTokenPayload = {
  cartao_numero: string;
  cartao_mes: string;
  cartao_ano: string;
};

export const requestTokenizeCard = async (
  cardData: createM4UCardTokenPayload,
) => {
  const { data } = await api.post('/m4u/v1/tokenizar-cartao', cardData);

  return data;
};
